import "./styles.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import menuIcon from "../../assets/icons/menu.svg";
import closeIcon from "../../assets/icons/close.png";
import userIcon from "../../assets/images/user-icon.png";
import dashboardIcon from "../../assets/images/dashboard-icon.png";
import Transport from "../../assets/images/railfreightoperators.png";
import GoldTransport from "../../assets/images/gold-railfreightoperators.png";
import Passenger from "../../assets/images/passenger.png";
import GoldPassenger from "../../assets/images/gold-passenger.png";
import Officer from "../../assets/images/officer.png";
import GoldOfficer from "../../assets/images/gold-officer.png";

import logoutIcon from "../../assets/icons/logout.svg";
import notiIcon from "../../assets/icons/noti.svg";

import { HttpRequest } from "../service/HttpRequest";
import { deleteCookie } from "../service/CookieManagement";
import { useAuth } from "../service/Authentication";
import DashboardPage from "../../page/dashboard";

import Logo from "../../assets/images/logo.png";

function Navbar(props) {
  let menuList = props.menuList;
  let dropdownList = props.dropdownList;
  let current_route = window.location.pathname;

  const [stateMenu, setStateMenu] = React.useState(false);
  const [stateNotiList, setStateNotiList] = React.useState(false);

  const [username, setUsername] = React.useState(null);

  const [notiList, setNotiList] = React.useState([]);
  const [notiAlert, setAlert] = React.useState(false);

  const [timerRefresh, setTimerRefresh] = React.useState(0);

  // set active page
  const [homeActive, setHomeActive] = React.useState(false);
  const [reportActive, setReportActive] = React.useState(false);
  // const [dashboardActive, setDashboardActive] = React.useState(true);

  // Icon Active
  const [passengerActive, setPassengerActive] = React.useState(false);
  const [transportActive, setTransportActive] = React.useState(false);
  const [agenciesActive, setAgenciesActive] = React.useState(false);

  // const AuthContext = useAuth();
  const navigate = useNavigate();

  /** LOGOUT TEST */
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  // utils/auth.js (or wherever you store auth-related functions)
  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    setShowLogoutConfirm(false); // Close the dialog
    logoutUser(); // Execute logout
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false); // Just close the dialog
  };
  const logoutUser = async () => {
    try {
      // Optional: Call your backend to invalidate the session/token
      // await fetch('/api/logout', { method: 'POST' });

      // Clear user data from client-side storage
      localStorage.removeItem("authToken"); // Or wherever you store your token
      // sessionStorage.removeItem('someData'); // If you use session storage

      // Redirect to login page or home page
      window.location.href = "/login"; // Or use React Router's history.push()
    } catch (error) {
      console.error("Logout failed:", error);
      // Handle error, e.g., show a notification to the user
    }
  };

  /** END LOGOUT TEST */

  async function onGetNotification(state = "") {
    // let param = {
    //   latitude: 13.84283,
    //   longitude: 100.67356,
    //   distancekm: 2000,
    //   starttime: null,
    //   stoptime: null,
    //   index: null,
    //   count: null,
    // };

    // await HttpRequest("/admin/getrecentfallingdetectionlist", param).then(
    //   (data) => {
    //     console.log("HttpRequest getrecentfallingdetectionlist :", data);
    //     if (data.result === "OK") {
    //       setNotiList(data.getrecentfallingdetectionlist);
    setAlert(true);
    //     }
    //   }
    // );
  }

  const onNavigatePage = (path) => {
    // console.log("onNavigatePage : ", path);
    navigate(path);
    setStateMenu(false);
  };

  const onReadAllNoti = () => {
    let _notis = [...notiList];
    for (let i = 0; i < _notis.length; i++) {
      _notis[i].read = true;
    }
    setNotiList(_notis);
  };

  const onReadByIndex = (index) => {
    let _notis = [...notiList];
    _notis[index].read = true;
    setNotiList(_notis);
  };

  // const onGetNotiCount = () => {
  //   // let countNoRead = notiList.filter((noti) => noti.read === false);
  //   // return countNoRead.length;
  //   return 1
  // };

  const getTimeWording = (time) => {
    let startDate = new Date(time);
    // Do your operations
    let endDate = new Date();
    let seconds = (endDate.getTime() - startDate.getTime()) / 1000;
    let minute = seconds / 60;
    let hour = minute / 60;
    let day = hour / 24;

    if (hour > 23) {
      return "เมื่อ " + parseInt(day) + " วันที่แล้ว";
    } else if (minute > 59) {
      return "เมื่อ " + parseInt(hour) + " ชั่วโมงที่แล้ว";
    } else if (seconds > 59) {
      return "เมื่อ " + parseInt(minute) + " นาทีที่แล้ว";
    } else {
      return "เมื่อสักครู่นี้";
    }
  };

  const twoDigit = (n) => {
    let number = parseInt(n);
    if (number <= 9) {
      return "0" + number;
    } else {
      return "" + number;
    }
  };

  const ConvertDate = (dateString, type = "datetime") => {
    if (dateString) {
      let date = new Date(dateString);
      if (type === "datetime") {
        return (
          date.getFullYear() +
          "-" +
          twoDigit(date.getMonth() + 1) +
          "-" +
          twoDigit(date.getDate()) +
          " " +
          twoDigit(date.getHours()) +
          ":" +
          twoDigit(date.getMinutes()) +
          ":" +
          twoDigit(date.getSeconds())
        );
      }
      if (type === "date") {
        return (
          date.getFullYear() +
          "-" +
          twoDigit(date.getMonth() + 1) +
          "-" +
          twoDigit(date.getDate())
        );
      }
      if (type === "time") {
        return (
          twoDigit(date.getHours()) +
          ":" +
          twoDigit(date.getMinutes()) +
          ":" +
          twoDigit(date.getSeconds())
        );
      }
    } else {
      return "";
    }
  };

  React.useEffect(() => {
    const controller = new AbortController();
    onGetNotification();
    // console.log()
    return () => {
      controller.abort();
    };
  }, []);

  const [leftMenu, setLeftMenu] = useState(false);

  const toggleMenu = () => {
    console.log("Toggle menu left handside");
    setLeftMenu(!leftMenu);
  };

  // React.useEffect(() => {
  //   const controller = new AbortController();

  //   if (AuthContext.user) {
  //     setUsername(AuthContext.user.username);
  //   }

  //   return () => {
  //     controller.abort();
  //   };
  // }, [AuthContext.user]);

  React.useEffect(() => {
    const controller = new AbortController();

    // console.log("timerRefresh : ", timerRefresh);

    // if (timerRefresh == 60) {
    //   setTimerRefresh(0);

    //   onGetNotification();
    // }

    return () => {
      controller.abort();
    };
  }, [timerRefresh]);

  React.useEffect(() => {
    const RefreshInternal = setInterval(() => {
      setTimerRefresh((t) => t + 1);
    }, 1000);
    return () => {
      clearInterval(RefreshInternal);
    };
  }, []);

  // On active btn
  const handleIconClick = (iconType) => {
    setPassengerActive(iconType === "passenger");
    setTransportActive(iconType === "transport");
    setAgenciesActive(iconType === "agencies");
  };

  return (
    <div className="navbar-main">
      <div className="navbar-container">
        
        {/** Header Img + Clip-path */}
        <div className="bg-color-header">
          <div className="logo-header">

            <div className="clip-path-img">
              <img src={Logo} alt="GHG_LOGO" />
              <div className="text-title-header">
                <div className="text-title-header1">
                  เครื่องมือการคำนวณก๊าซเรือนกระจกและ
                </div>
                <div className="text-title-header1">
                  มลภาวะทางอากาศ ในภาคการขนส่งทางราง
                </div>
                <div className="text-title-header2">
                  กรมการขนส่งทางราง {`(Department of Rail Transport)`}
                </div>
              </div>
              <div className="clip-path"></div>
            </div> 
              
          </div>
        </div>

        {/* Slide Menu */}
        {/* <div className={`sidebar ${leftMenu ? "open" : ""}`}>
          <div className="is-menu">
            <div
              style={{
                paddingBottom: "5px",
              }}
            >
              หน้าหลัก
            </div>
            <div className="item-slid">
              <li>เปรียบเทียบเมื่อเปลี่ยนรูปแบบการขนส่ง </li>
              <div>{`>`}</div>
            </div>
            <div className="item-slid">
              <li>แบบช่วยคำนวณเมื่อดำเนินโครงการ T-Ver </li>
              <div>{`>`}</div>
            </div>
            <div className="item-slid">
              <li>แบบฟอร์มเอกสารที่เกียวข้อง</li>
              <div>{`>`}</div>
            </div>
            <div className="item-slid">
              <li>หนังสืออิเล็กทรอนิกส์ </li>
              <div>{`>`}</div>
            </div>
            <div className="item-slid">
              <li>สำหรับผู้ดูแลข้อมูล </li>
              <div>{`>`}</div>
            </div>
          </div>
          {leftMenu ? (
            <div className="i">
              <div className="in">{`<`}</div>
              <div className="btn-click" onClick={toggleMenu}>
                COLLASE
              </div>
            </div>
          ) : (
            <div className="i">
              <div className="in">{`>`}</div>
              <div className="btn-click" onClick={toggleMenu}>
                COLLASE
              </div>
            </div>
          )}
        </div> */}

        <div className="header-title">ตัวเลือกรูปแบบการคำนวณ</div>

        <div className="container-a">

          <div className="group-icon-btn">

            {/**Icon 1 */}
            <div
              className="group-passenger"
              onClick={() => onNavigatePage("/passenger")}
            >
              {/* <div className="name-calculate">ผู้โดยสารรถไฟ</div> */}
              <div
                className="menu-item"
                style={{
                  backgroundColor: passengerActive ? "#000" : null,
                  cursor: "pointer",
                }}
                onClick={() => handleIconClick("passenger")}
              >
                <img
                  src={passengerActive ? GoldPassenger : Passenger}
                  alt="passenger"
                />
              </div>
              <div className="detail-passenger">
                ผู้โดยสารรถไฟ / รถไฟฟ้า
              </div>
              {/* <div className="detail-passenger">
                เปรียบเทียบก๊าซเรือนกระจก
                และมลภาวะทางอากาศที่ลดลงจากการโดยสารรถไฟ
              </div> */}
            </div>

            {/**Icon 2 */}    
            <div
              className="group-transport"
              onClick={() => onNavigatePage("/transport")}
            >
              {/* <div className="name-calculate">ผู้ประกอบการขนส่งสินค้าทางราง</div> */}
              <div
                className="menu-item"
                style={{
                  backgroundColor: transportActive ? "#000" : null,
                  cursor: "pointer",
                }}
                onClick={() => handleIconClick("transport")}
              >
                <img
                  src={transportActive ? GoldTransport : Transport}
                  alt="transport"
                />
              </div>
              <div className="detail-transport">
                ผู้ประกอบการขนส่งสินค้าทางรถไฟ
              </div>
              {/* <div className="detail-transport">
                เปรียบเทียบก๊าซเรือนกระจก
                และมลภาวะทางอากาศที่ลดลงจากการขนส่งสินค้าทางราง
              </div> */}
            </div>

             {/**Icon 3 */}    
            <div
              className="group-agencies"
              onClick={() => onNavigatePage("/agencies")}
            >
              {/* <div className="name-calculate">หน่วยงานที่เกี่ยวข้องกับการขนส่งทางราง</div> */}
              <div
                className="menu-item"
                style={{
                  backgroundColor: agenciesActive ? "#000" : null,
                  cursor: "pointer",
                }}
                onClick={() => handleIconClick("agencies")}
              >
                <img
                  src={agenciesActive ? GoldOfficer : Officer}
                  alt="agencies"
                />
              </div>
              <div className="detail-agencies">
                หน่วยงานดำเนินโครงการที่เกี่ยวข้องกับการขนส่งทางราง
              </div>
              {/* <div className="detail-agencies">
                เปรียบเทียบก๊าซเรือนกระจก
                และมลภาวะทางอากาศที่ลดลงจากการดำเนินงาน
              </div> */}
            </div>
          </div>

        </div>


      </div>
    </div>
  );
}

export default Navbar;
